export default __webpack_public_path__ + "static/media/flogo.7c1c97d7.png";